var __default__ = {root:'m_dc6f14e2'};
export default __default__;